import AttachmentsCase from '../components/AttachmentsCase'
import CaseInvestigation from '../components/CaseInvestigation'
import CaseOverview from '../components/CaseOverview'
import CaseTimeline from '../components/CaseTimeline'
import CaseUpdates from '../components/CaseUpdates'
import ExportCase from '../components/ExportCase'
import Inbox from '../components/Inbox'
import InitialReport from '../components/InitialReport'
import NewCase from '../components/NewCase'
import ResolveCase from '../components/ResolveCase'
import ArchivePage from '../pages/ArchivePage'
import CasesPage from '../pages/CasesPage'
import ExportPage from '../pages/ExportPage'
import MetricsPage from '../pages/MetricsPage'
import UsersPage from '../pages/UsersPage'
import { IRoute } from './types'

const protectedRoutes: IRoute[] = [
  {
    path: '/archive',
    name: 'Archives Page',
    component: ArchivePage,
    exact: true,
  },
  {
    path: '/users',
    name: 'Users Page',
    component: UsersPage,
    exact: true,
  },
  {
    path: '',
    name: 'CasesPage',
    component: CasesPage,
    exact: true,
    children: [
      {
        path: 'cases/newCase',
        name: 'New Case',
        component: NewCase,
        exact: true,
      },
      {
        path: 'cases/initialReport',
        name: 'InitialReport',
        component: InitialReport,
        exact: true,
      },
      {
        path: 'cases/inbox',
        name: 'Inbox',
        component: Inbox,
        exact: true,
      },
      {
        path: 'cases/overview',
        name: 'Overview',
        component: CaseOverview,
        exact: true,
      },
      {
        path: 'cases/investigation',
        name: 'Overview',
        component: CaseInvestigation,
        exact: true,
      },
      {
        path: 'cases/timeline',
        name: 'Resolve Case',
        component: CaseTimeline,
        exact: true,
      },
      {
        path: 'cases/attachments',
        name: 'Overview',
        component: AttachmentsCase,
        exact: true,
      },
      {
        path: 'cases/export',
        name: 'Resolve Case',
        component: ExportCase,
        exact: true,
      },
      {
        path: 'cases/resolve',
        name: 'Resolve Case',
        component: ResolveCase,
        exact: true,
      },
      {
        path: 'cases/updates',
        name: 'Case Updates',
        component: CaseUpdates,
        exact: true,
      },
      {
        path: '*',
        name: 'Inbox',
        component: Inbox,
        exact: true,
      },
    ],
  },
  {
    path: '/export',
    name: 'Export Page',
    component: ExportPage,
    exact: true,
  },
  {
    path: '/metrics',
    name: 'Metrics Page',
    component: MetricsPage,
    exact: true,
  },
]

export default protectedRoutes
